import SpriteSymbol from "../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 357 357",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 357 357\" id=\"plus\">\n\t\t<path d=\"M357,204H204v153h-51V204H0v-51h153V0h51v153h153V204z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol